import { IconInterface } from '../interfaces/icon.interface';

export const TruckApprove = (props: IconInterface) => {
	const {
		color = '#A2A2A2',
		width = 20,
		height = 20,
		strokeWidth = '1.6',
	} = props;

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M15 18H9"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle cx="17" cy="18" r="2" stroke={color} strokeWidth={strokeWidth} />
			<circle cx="7" cy="18" r="2" stroke={color} strokeWidth={strokeWidth} />
		</svg>
	);
};
